export default __webpack_public_path__ + "text-height-adjustment.png";